import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { notification } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import websocketClient from '../services/websocket';
import NotificationSound from './NotificationSound';

/**
 * 全局 WebSocket 通知组件
 * 在整个应用中监听 WebSocket 消息并显示通知
 */
const GlobalNotification = () => {
  const playSoundRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // WebSocket 连接由 WebSocketProvider 管理

    // 监听新充值通知
    const handleNewRecharge = (data) => {
      console.log('收到新充值通知:', data);
      
      const orderType = data.data?.orderType;
      const amount = data.data?.amount || 0;
      const currencyCode = data.data?.currencyCode || 'CNY';
      const currencySymbol = currencyCode === 'CNY' ? '¥' : currencyCode;
      
      let message = '商户充值申请';
      let description = '';
      let iconColor = '#52c41a';
      let navigatePath = '/finance/recharge';
      
      if (orderType === 'collection') {
        message = '收款订单';
        description = `收到新的收款订单，金额：${currencySymbol}${amount}`;
        navigatePath = '/third-party/orders';
      } else {
        description = `商户提交了充值申请，金额：¥${amount}`;
      }
      
      // 播放提示音
      if (playSoundRef.current) {
        playSoundRef.current();
      }

      // 显示通知
      notification.info({
        message,
        description,
        icon: <DollarOutlined style={{ color: iconColor }} />,
        duration: 5,
        onClick: () => {
          navigate(navigatePath);
        },
      });

      // 如果当前在对应页面，触发自定义事件通知页面刷新
      if (location.pathname === navigatePath) {
        window.dispatchEvent(new CustomEvent('recharge-updated'));
      }
    };

    // 监听新提现通知
    const handleNewWithdraw = (data) => {
      console.log('收到新提现通知:', data);
      
      const orderType = data.data?.orderType;
      const amount = data.data?.amount || 0;
      const currencyCode = data.data?.currencyCode || 'CNY';
      const currencySymbol = currencyCode === 'CNY' ? '¥' : currencyCode;
      
      let message = '新提现申请';
      let description = '';
      let iconColor = '#faad14';
      let navigatePath = '/finance/withdraw';
      
      if (orderType === 'withdrawal') {
        message = '代付订单';
        description = `收到新的代付订单，金额：${currencySymbol}${amount}`;
        navigatePath = '/third-party/withdrawals';
      } else {
        description = `商户提交了提现申请，金额：¥${amount}`;
      }
      
      // 播放提示音
      if (playSoundRef.current) {
        playSoundRef.current();
      }

      // 显示通知
      notification.info({
        message,
        description,
        icon: <DollarOutlined style={{ color: iconColor }} />,
        duration: 5,
        onClick: () => {
          navigate(navigatePath);
        },
      });

      // 如果当前在对应页面，触发自定义事件
      if (location.pathname === navigatePath) {
        window.dispatchEvent(new CustomEvent('withdraw-updated'));
      }
    };

    websocketClient.on('new_recharge', handleNewRecharge);
    websocketClient.on('new_withdraw', handleNewWithdraw);

    // 清理
    return () => {
      websocketClient.off('new_recharge', handleNewRecharge);
      websocketClient.off('new_withdraw', handleNewWithdraw);
    };
  }, [location.pathname, navigate]);

  return <NotificationSound onPlay={(playFn) => { playSoundRef.current = playFn; }} />;
};

export default GlobalNotification;
